import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CustomInput = ({type = 'text', icon, title, placeholder, autoFocus = false, borderBottom = false, onChange}) => {
    return (
        <div className="ct_cinput">
            <div className={`sub_ct_cinput ${borderBottom ? 'bd_bottom' : ''}`}>
                <div className="ct_cinput_l">
                    <FontAwesomeIcon className="fa_icon" icon={icon} />
                </div>
                <div className="ct_cinput_r">
                    <div className="title">
                        {title}
                    </div>
                    <div className="cinput">
                        <input type={type} autoFocus={autoFocus} placeholder={placeholder} onChange={event => onChange(event.target.value)} />
                    </div>
                </div>
            </div>
        </div>
    ) 
}

export default CustomInput;